import React from 'react';
import TabelaDinamica from '~/Components/TabelaDinamica/Tabela';
import { normalizarLista } from '../utils';

const renderCelula = (coluna, item) => {
  const value = item[coluna.key];

  if (typeof coluna.render === 'function') {
    return coluna.render(value, item);
  }

  if (value == null) return '-';
  return value;
};

const TabelaFluxoCaixa = ({
  colunas = [],
  dados = [],
  cellLineHeight = 'normal',
  cellPadding = '12px 16px',
  cellWhiteSpace = 'normal',
  fontSize = '14px',
  minWidth = '100%',
  tableLayout = 'auto',
  verticalAlign = 'middle',
  ...props
}) => {
  const linhas = normalizarLista(dados).filter(item => !item.is_total);
  const total = normalizarLista(dados).find(item => item.is_total);

  return (
    <div className="fluxo-caixa-dw-sticky-table">
      <TabelaDinamica
        {...props}
        cellLineHeight={cellLineHeight}
        cellPadding={cellPadding}
        cellWhiteSpace={cellWhiteSpace}
        colunas={colunas}
        dados={linhas}
        fontSize={fontSize}
        minWidth={minWidth}
        tableLayout={tableLayout}
        verticalAlign={verticalAlign}
      />
      {total && (
        <table
          className="fluxo-caixa-dw-total-table"
          style={{
            minWidth,
            tableLayout,
          }}
        >
          <tbody>
            <tr>
              {colunas.map(coluna => (
                <td
                  key={coluna.key}
                  style={{
                    width: coluna.width || 'auto',
                    padding: coluna.cellPadding || cellPadding,
                    fontSize: coluna.fontSize || fontSize,
                    lineHeight: coluna.cellLineHeight || cellLineHeight,
                    whiteSpace: coluna.cellWhiteSpace || cellWhiteSpace,
                    verticalAlign,
                    textAlign: coluna.align || 'left',
                  }}
                >
                  {renderCelula(coluna, total)}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TabelaFluxoCaixa;
